module.exports = __webpack_public_path__ + "public/img/total.1f367285.png";